
import apis from "@/apis";
import { isweixin } from "./index";

let wx_js_sdk = require('weixin-js-sdk')

let title = "我信赖的福龄生活家庭服务推荐给你";
let desc = "居家保洁/家电清洗/深度保洁，更多家庭服务等你体验";
let _domain_origin = location.origin + '/';
let _imgsrc = "static/logo_mini.png";
// let _imgsrc = "static/share.jpg";
let imgUrl = _domain_origin + _imgsrc; // 分享图标
let successFn = function (res) {
    console.log('wsshare success', res);
};
let errorFn = function (res) {
    console.log('wsshare error', res);
}
let signPackageData = null;
let cache_wxconfig = null;

export async function initWxInterface(config) {
    // console.error('initWxInterface');
    if (!isweixin()) {
        return;
    }
    // let link = location.href;
    let link = location.origin;
    let shareConfig = {
        // 获取JS-SDK使用权限签名
        title, // 分享标题
        desc, // 分享描述
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        successFn,
        errorFn,
        ...config
    }
    if (shareConfig && shareConfig.link) {
        let aa = "";
        aa = shareConfig.link;
        // aa = "http://mall-h5.mall.968885.org/#/sd?sid=11";
        // if (aa.indexOf('?') == -1) {
        //     aa += '?from=singlemessage'
        // } else {
        //     aa += '&from=singlemessage'
        // }
        if (aa.indexOf('#') > -1) {
            if (aa.indexOf('?') > -1) {
                aa = aa.replace('?', '&');
            }
            aa = aa.replace('/#/', '?hash=');
        }
        shareConfig._linkSource1 = shareConfig.link;
        shareConfig._linkSource2 = aa;
        shareConfig.link = aa;
        // shareConfig.link = encodeURIComponent(aa);
    }
    if (cache_wxconfig && shareConfig.link == cache_wxconfig.link && shareConfig.title == cache_wxconfig.title) {
        // return;
    }
    cache_wxconfig = shareConfig;
    let params = {
        url: encodeURIComponent(location.href.split('#')[0])
    };
    if (!signPackageData || !signPackageData.appId || !signPackageData.nonceStr || !signPackageData.timestamp || !signPackageData.signature) {
        console.log('wsshare sign_package', { params });
        signPackageData = await apis.wechat.sign_package(params);
    }
    setTimeout(() => {
        console.log('wsshare cache_wxconfig', { cache_wxconfig });
        if (cache_wxconfig && cache_wxconfig.link) {
            initwx({ signPackageData, shareConfig: cache_wxconfig });
        } else {
            console.error('cache_wxconfig is null');
        }
    }, 100);
    // setTimeout(() => {
    //     console.log('wsshare cache_wxconfig', { cache_wxconfig });
    //     if (cache_wxconfig && cache_wxconfig.link) {
    //         initwx({ signPackageData, shareConfig: cache_wxconfig });
    //     } else {
    //         console.error('cache_wxconfig is null');
    //     }
    // }, 2000);
};

export const initwx = ({ signPackageData, shareConfig }) => {
    console.log('wsshare initwx', signPackageData, shareConfig);
    if (!signPackageData.appId || !signPackageData.nonceStr || !signPackageData.timestamp || !signPackageData.signature) {
        console.error('wsshare initwx Error');
        return
    }
    wx_js_sdk.config({
        debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: signPackageData.appId, // 必填，公众号的唯一标识
        timestamp: signPackageData.timestamp, //必填，生成签名的时间戳 
        nonceStr: signPackageData.nonceStr, //必填，生成签名的随机串
        signature: signPackageData.signature,// 必填，签名
        jsApiList: [// 必填，需要使用的JS接口列表
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareTimeline',
            'onMenuShareQZone',
            'onMenuShareWeibo',
            'getLocation'
        ]
    });
    wx_js_sdk.ready(function () { //需在用户可能点击分享按钮前就先调用
        console.log('wsshare ready', signPackageData, shareConfig);
        if (wx_js_sdk.onMenuShareAppMessage) {
            wx_js_sdk.onMenuShareAppMessage({
                ...shareConfig,
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: shareConfig.successFn// 用户点击了分享后执行的回调函数
            });
            wx_js_sdk.onMenuShareQQ({
                ...shareConfig,
                success: shareConfig.successFn,// 用户点击了分享后执行的回调函数
                cancel: shareConfig.errorFn // 用户取消分享后执行的回调函数
            });
        } else {
            wx_js_sdk.updateAppMessageShareData({
                ...shareConfig,
            }, function (res) {
                //这里是回调函数 
                shareConfig.successFn(res)
            });
        }
        if (wx_js_sdk.onMenuShareTimeline) {
            wx_js_sdk.onMenuShareTimeline({
                ...shareConfig,
                success: shareConfig.successFn, // 用户点击了分享后执行的回调函数
            });
            wx_js_sdk.onMenuShareQZone({
                ...shareConfig,
                success: shareConfig.successFn, // 用户确认分享后执行的回调函数
                cancel: shareConfig.errorFn // 用户取消分享后执行的回调函数
            });
        } else {
            wx_js_sdk.updateTimelineShareData({
                ...shareConfig,
            }, function (res) {
                //这里是回调函数 
                shareConfig.successFn(res)
            });
        }
        wx_js_sdk.onMenuShareWeibo({
            ...shareConfig,
            success: shareConfig.successFn,// 用户确认分享后执行的回调函数
            cancel: shareConfig.errorFn// 用户取消分享后执行的回调函数
        });
    });
    //     // window.location = window.location.href
}

export function getWXLocation() {
    function s(r) {
        console.log('getLocation s', { r });
    }
    function f(r) {
        console.log('getLocation f', { r });
    }
    return new Promise((r = s, e = f) => {
        try {
            wx_js_sdk.getLocation({
                success: r,
                cancel: e
            });
        } catch (e) {
            e(e)
        }
    });
}


// WEBPACK FOOTER //
// ./src/utils/wxShare.js